import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import {consoleDebugger} from "@/utils/index"

/*import {
  getLocalStorage,
  saveLocalStorage
} from '@/utils/auth.js'*/
import './styles/element-variables.scss'
import ElementUI from 'element-ui'
// import enLang from 'element-ui/lib/locale/lang/en'// 如果使用中文语言包请默认支持，无需额外引入，请删除该依赖
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
import './styles/index.scss' // global css
import './styles/mixin.scss' // global css
Vue.config.productionTip = false
if (process.env.NODE_ENV !== 'development') {
  consoleDebugger();
// 屏蔽错误信息
  Vue.config.errorHandler = (err) => {
    console.log(err)
  }
  // 屏蔽警告信息
  Vue.config.warnHandler = (message) => {
    console.log(message)
  }
  // 屏蔽输出内容
  console.log = function() {}
  console.error = function() {}
}
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
